const DataTypes = Object.freeze({
  TIME: 'TIME'
});

export { DataTypes };
